import { withStyles } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";

const styles = theme => ({
    root: {
        backgroundColor: `${theme.palette.type === "dark" ? "#424242" : "#E6E6E6"} !important`,
    },
    spinner: {
        border: "10px solid " + (window.sessionStorage.getItem("theme") ? window.sessionStorage.getItem("theme") : "#459DC2")
    }
});

const FuseSplashScreen = ({ theme, classes }) => {
    return (
        <div id="fuse-splash-screen" className={classNames(classes.root)}>
            <div className="center">
                <div className="spinner-wrapper">
                    <div className="spinner">
                        <div className="inner">
                            <div className="gap" />
                            <div className="left">
                                <div className={classNames(classes.spinner, "half-circle")} />
                            </div>
                            <div className="right">
                                <div className={classNames(classes.spinner, "half-circle")} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps({ fuse }) {
    return {
        theme: fuse.settings.mainTheme
    }
}

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(FuseSplashScreen));